import AttitudesInJerusalem from "../Contents2/AttitudesInJerusalem";
import BahaiGardens from "../Contents2/BahaiGardens";
import BahaiShrine from "../Contents2/BahaiShrine";
import BasilicaOfAnnunciation from "../Contents2/BasilicaOfAnnunciation";
import Bethany from "../Contents2/Bethany";
import Bethlehem from "../Contents2/Bethlehem";
import BurningBush from "../Contents2/BurningBush";
import Cairo from "../Contents2/Cairo";
import CairoMuseum from "../Contents2/CairoMuseum";
import Canaan from "../Contents2/Canaan";
import ChurchOfNativity from "../Contents2/ChurchOfNativity";
import ChurchOfStPeter from "../Contents2/ChurchOfStPeter";
import DavidGoliathValey from "../Contents2/DavidGoliathValey";
import DeadSea from "../Contents2/DeadSea";
import DomeOfTheRockTempleMount from "../Contents2/DomeOfTheRockTempleMount";
import DominousFlevitInJerusalem from "../Contents2/DominousFlevitInJerusalem";
import ElishaSpringsInJerusalem from "../Contents2/ElishaSpringsInJerusalem";
import GalilieanBoadRide from "../Contents2/GalilieanBoadRide";
import GardenOfGathsemane from "../Contents2/GardenOfGathsemane";
import GardenTomb from "../Contents2/GardenTomb";
import Golgotha from "../Contents2/Golgotha";
import Grotto from "../Contents2/Grotto";
import Haifa from "../Contents2/Haifa";
import HolyMaryChurchInEgypt from "../Contents2/HolyMaryChurchInEgypt";
import HouseOfCaiphas from "../Contents2/HouseOfCaiphas";
import JoppaCity from "../Contents2/JoppaCity";
import Jordanriver from "../Contents2/JordanRiver";
import LastSuperRoom from "../Contents2/LastSuperRoom";
import LazarusTomb from "../Contents2/LazarusTomb";
import MadabaStGeorgesChurch from "../Contents2/MadabaStGeorgesChurch";
import MaraAndElim from "../Contents2/MaraAndElim";
import MarysWell from "../Contents2/MarysWell";
import MediterraneanSea from "../Contents2/MediterraneanSea";
import MensaChristiCapernaum from "../Contents2/MensaChristiCapernaum";
import MosesWell from "../Contents2/MosesWell";
import MtCarmel from "../Contents2/MtCarmel";
import MtNebo from "../Contents2/MtNebo";
import MtOlives from "../Contents2/MtOlives";
import MtTaborSiteOfTransfiguration from "../Contents2/MtTaborSiteOfTransfiguration";
import MtTemptation from "../Contents2/MtTemptation";
import Muharaga from "../Contents2/Muharaga";
import Nazareth from "../Contents2/Nazareth";
import PillarOfSalt from "../Contents2/PillarOfSalt";
import PoolOfBethesda from "../Contents2/PoolOfBethesda";
import PyramidsAndSphinx from "../Contents2/PyramidsAndSphinx";
import ReadSea from "../Contents2/ReadSea";
import RiverJabbok from "../Contents2/RiverJabbok";
import ShephardsFieldInBethlehem from "../Contents2/ShephardsFieldInBethlehem";
import SimonTheTannerStPeterChurch from "../Contents2/SimonTheTannerStPeterChurch ";
import SycamoreTree from "../Contents2/SycamoreTree";
import TabaBorderCrossing from "../Contents2/TabaBorderCrossing";
import TabghaChurch from "../Contents2/TabghaChurch";
import TombOfKingDavid from "../Contents2/TombOfKingDavid";
import Via14Stations from "../Contents2/Via14Stations";
import WesternWailingWall from "../Contents2/WesternWailingWall";

export const Description = [
  {
    element: <HouseOfCaiphas/>,
    path:"houseofcaiphas",
  },
  {
    element: <BahaiGardens/>,
    path:"bahaigardens",
  },
  {
    element: <SimonTheTannerStPeterChurch/>,
    path:"simonthetanner",
   },
  {
    element: <Nazareth/>,
    path:"nazareth",
   },
  {
    element: <MtOlives/>,
    path:"mountolives",
   },
  {
    element: <MtNebo/>,
    path:"mountnebo",
   },
  {
    element: <Haifa/>,
    path:"haifa",
   },
  {
    element: <Canaan/>,
    path:"canaan",
   },
   {
    element: <CairoMuseum/>,
    path:"cairoMuseum",
   },
    {
      element: <Jordanriver/>,
      path:"jordanriver",
    },
    {
      element:<Bethlehem/>,
      path:"bethlehem",
    },
    {
      element:<WesternWailingWall/>,
      path:"western",
    },
    {
      element:<PoolOfBethesda/>,
      path:"pool",
    },
    {
      element:<DomeOfTheRockTempleMount/>,
      path:"dome",
    },
    {
      element:<ShephardsFieldInBethlehem/>,
      path:"shephardsfield",
    },
    {
      element:<Via14Stations/>,
      path:"via14",
    },
    {
      element:<Golgotha/>,
      path:"golgotha",
    },
    {
      element:<Bethany/>,
      path:"bethany",
    },
    {
      element:<LazarusTomb/>,
      path:"lazarus",
    },
    {
      element:<ChurchOfNativity/>,
      path:"churchNativity",
    },
    {
      element:<Grotto/>,
      path:"grotto",
    },
    {
      element:<MtTemptation/>,
      path:"mtTemptation",
    },
    {
      element:<SycamoreTree/>,
      path:"sycamore",
    },
    {
      element:<DeadSea/>,
      path:"dead",
    },
    {
      element:<TabaBorderCrossing/>,
      path:"taba",
    },
    {
      element:<MosesWell/>,
      path:"moses",
    },
    {
      element:<BurningBush/>,
      path:"burning",
    },
    {
      element:<Cairo/>,
      path:"cairo",
    },
    {
      element:<ReadSea/>,
      path:"read",
    },
    {
      element:<MaraAndElim/>,
      path:"maraelim",
    },
    {
      element:<PyramidsAndSphinx/>,
      path:"pyramids",
    },
    {
      element:<HolyMaryChurchInEgypt/>,
      path:"holy",
    },
    {
      element:<DominousFlevitInJerusalem/>,
      path:"dominoues",
    },
    {
      element:<GardenOfGathsemane/>,
      path:"gardenGethsemane",
    },
    {
      element:<GardenTomb/>,
      path:"gardenTomb",
    },
    {
      element:<LastSuperRoom/>,
      path:"superRomm",
    },
    {
      element:<TombOfKingDavid/>,
      path:"kingDavid",
    },
    {
      element:<ChurchOfStPeter/>,
      path:"stPeter",
    },
    {
      element:<MtTaborSiteOfTransfiguration/>,
      path:"mtTabor",
    },
    {
      element:<MtCarmel/>,
      path:"mtCarmel",
    },
    {
      element:<BahaiShrine/>,
      path:"bahaiShrine",
    },
    {
      element:<Muharaga/>,
      path:"muharaga",
    },
    {
      element:<MediterraneanSea/>,
      path:"mediterranean",
    },
    {
      element:<JoppaCity/>,
      path:"joppa",
    },
    {
      element:<TabghaChurch/>,
      path:"tabgha",
    },
    {
      element:<MensaChristiCapernaum/>,
      path:"mensa",
    },
    {
      element:<GalilieanBoadRide/>,
      path:"galilean",
    },
    {
      element:<MarysWell/>,
      path:"marysWell",
    },
    {
      element:<BasilicaOfAnnunciation/>,
      path:"basilica",
    },
    {
      element:<MadabaStGeorgesChurch/>,
      path:"madaba",
    },
    {
      element:<DavidGoliathValey/>,
      path:"davidGoliath",
    },
    {
      element:<PillarOfSalt/>,
      path:"pillar",
    },
    {
      element:<RiverJabbok/>,
      path:"riverJabbok",
    },
    {
      element:<AttitudesInJerusalem/>,
      path:"attitudes",
    },
    {
      element:<ElishaSpringsInJerusalem/>,
      path:"elisha",
    }
  ]
  